var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { WriteableReplicatedObject } from "../server/WriterContext";
export function playerRecordsView(oldData, newData, playerId, hasEnoughPlayers) {
    const playerRecordsResult = Object.create(null);
    Object.keys(newData.record).map((key, index) => {
        const playerRecord = newData.record[key];
        playerRecordsResult[key] = Object.assign(Object.assign({}, playerRecord), { isLocalPlayer: playerRecord.playerId === playerId, index });
    });
    const getPlayerUsername = (playerId) => {
        var _a, _b;
        return playerId ? (_b = (_a = playerRecordsResult[playerId]) === null || _a === void 0 ? void 0 : _a.username) !== null && _b !== void 0 ? _b : '-_' : '-_';
    };
    const getPlayerIds = () => {
        return [...Object.keys(playerRecordsResult)];
    };
    return Object.assign(Object.assign({}, newData), { record: playerRecordsResult, getPlayerUsername,
        getPlayerIds, hasEnoughPlayers: () => hasEnoughPlayers(Object.values(playerRecordsResult).length) });
}
export class WriteablePlayerRecords extends WriteableReplicatedObject {
    afterCommitPlayerChange(oldData, isDeleting) { }
    onGameOver(lastGameSummary) { return lastGameSummary; }
    afterCommitData(oldData) {
        this.afterCommitPlayerChange(oldData, false);
        if ( /*this.context.gameLifecycleStage === 'Ingame' &&*/!this.data.hasEnoughPlayers()) {
            const summary = this.onGameOver({
                gameEndReason: 'NotEnoughPlayers',
                details: {}
            });
            this.context.commitEndGame(summary);
        }
    }
    afterCommitDelete() {
        this.afterCommitPlayerChange(this.data, true);
    }
    commitPlayerRecordData(playerId, data) {
        this.commitData({
            record: Object.assign(Object.assign({}, this.data.record), { [playerId]: Object.assign(Object.assign({}, this.data.record[playerId]), data) })
        });
    }
    deletePlayerRecord(playerId) {
        const _a = this.data.record, _b = playerId, playerRecordToDelete = _a[_b], playerRecordsToRetain = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
        this.commitData({
            record: playerRecordsToRetain,
        });
    }
}
//# sourceMappingURL=PlayerRecords.js.map